<navigation></navigation>
<div class="container">
  <div class="row">
    <wireless-subscriptions-filter
      class="col-4 col-filter"
      [collectedTags]="collectedTags()"
      [(activeTags)]="activeTags"
      [(servicesSearch)]="servicesSearch"
      [tickets]="tickets()"
      [suppliers]="suppliers()"
    />
    <wireless-subscriptions-results
      class="col-12 col-md-8 col-content"
      [subscriptions]="filteredSubscriptions()"
      [tickets]="tickets()"
    />
  </div>
</div>
<div class="container">
  <footer></footer>
</div>
